var globalhome = {
    heroTitleTop:"Bienvenido a",
    heroTitleMain:"Marival",
    heroTitleMainAccent:"for Agents",
    heroSuccessTitle:"Tu éxito es nuestra prioridad",
    heroSuccessText:"Todo lo que necesitas para vender con confianza Marival Resorts, aumentar tus comisiones, premiar tu lealtad y ofrecer vacaciones inolvidables—todo en un solo lugar.",

    resortsTitle:"Descubre nuestros resorts",
    perfectForLabel:"Ideal para:",
    closeLabel:"Cerrar",

    resort1Name:"Marival Emotions Resort & Suites Riviera Nayarit by Mercure",
    resort1Tagline:"Diversión. Energía. Recuerdos en familia.",
    resort1Desc:"Un vibrante resort todo incluido donde todas las generaciones se reúnen para crear recuerdos inolvidables. Habitaciones amplias, actividades sin fin, entretenimiento y un valor excepcional hacen de Emotions la opción perfecta para unas vacaciones familiares activas.",
    resort1PerfectFor:["Familias","Viaje multigeneracional","Vacaciones activas","Bodas","Gran valor"],

    resort2Name:"Marival Distinct All-Suites & World Spa – Handwritten Collection",
    resort2Tagline:"Espacio. Confort. Experiencias elevadas.",
    resort2Desc:"Una experiencia todo incluido de alto nivel con residencias lujosas, servicio personalizado, amenidades exclusivas y gastronomía refinada. Diseñada para familias y grupos que buscan más espacio, confort y unas vacaciones más sofisticadas.",
    resort2PerfectFor:["Familias de lujo","Reuniones familiares","Grupos pequeños","Viaje multigeneracional","Viajeros premium todo incluido","Bodas"],

    resort3Name:"Armony Marival Resort & Spa Punta de Mita – MGallery Collection",
    resort3Tagline:"Naturaleza. Bienestar. Serenidad.",
    resort3Desc:"Un tranquilo refugio frente al mar donde el bienestar, la naturaleza y la relajación son protagonistas. Las familias reconectan a través de experiencias inmersivas mientras los adultos disfrutan de áreas exclusivas para adultos diseñadas para una tranquilidad total.",
    resort3PerfectFor:["Viajeros de bienestar","Parejas","Amantes del lujo","Escapadas familiares relajadas","Bodas"],

    promiseEyebrow:"La promesa Marival",
    promiseTitle:"Tres resorts distintivos. Una promesa excepcional.",
    promiseIntro:"Por más de 40 años, Marival Resorts ha recibido a sus huéspedes con auténtica hospitalidad mexicana, ofreciendo experiencias todo incluido excepcionales en el corazón de Riviera Nayarit, a solo minutos del auténtico Puerto Vallarta.",
    promise1Name:"Empresa familiar con raíces locales",
    promise1Text:"Orgullosamente empresa familiar desde 1985, profundamente comprometida con nuestro destino, nuestra comunidad y una hospitalidad auténtica.",
    promise2Name:"Maestros del Todo Incluido",
    promise2Text:"Más de cuatro décadas de experiencia brindando un servicio excepcional, excelencia culinaria y experiencias memorables para los huéspedes.",
    promise3Name:"Una experiencia de playa excepcional",
    promise3Text:"Hermosas playas del Pacífico, costa apta para nadar y momentos inolvidables junto al mar."
}
module.exports = globalhome
